import { type DocumentNode } from 'graphql';
import gql from 'graphql-tag';

export const PROVISIONING_APP_RELEASES_QUERY: DocumentNode = gql`
  query ProvisioningAppReleases(
    $deviceIMEIListInput: DeviceIMEIListInput!
    $packageNameListInput: PackageNameListInput!
  ) {
    provisioningAppReleases(
      deviceIMEIListInput: $deviceIMEIListInput
      packageNameListInput: $packageNameListInput
    ) {
      resolved {
        imei
        releases {
          progetApplicationUUID
          packageName
          name
          version
          versionCode
          sizeBytes
        }
      }
      failed {
        imei
        code
        message
      }
    }
  }
`;

export const ASSIGN_PROGET_PROVISIONING_GROUP_MUTATION: DocumentNode = gql`
  mutation AssignProgetProvisioningGroup($deviceIMEIInput: DeviceIMEIInput!) {
    assignProgetProvisioningGroup(deviceIMEIInput: $deviceIMEIInput) {
      imei
      alias
    }
  }
`;

export const DISABLE_KIOSK_MODE_MUTATION: DocumentNode = gql`
  mutation ForjaDisableKioskMode($deviceIMEIInput: DeviceIMEIInput!) {
    disableKioskMode(deviceIMEIInput: $deviceIMEIInput) {
      isKioskModeEnabled
    }
  }
`;

export const PUSH_MOS_MANAGED_CONFIGURATION_MUTATION: DocumentNode = gql`
  mutation ForjaPushMOSManagedConfiguration($deviceIMEIInput: DeviceIMEIInput!) {
    pushProgetMOSManagedConfiguration(deviceIMEIInput: $deviceIMEIInput) {
      imei
      packageName
    }
  }
`;

export const ENABLE_KIOSK_MODE_MUTATION: DocumentNode = gql`
  mutation ForjaEnableKioskMode($deviceIMEIInput: DeviceIMEIInput!) {
    enableKioskMode(deviceIMEIInput: $deviceIMEIInput) {
      isKioskModeEnabled
    }
  }
`;

export const FORJA_DEVICES_QUERY: DocumentNode = gql`
  query ForjaDevices($criteria: DeviceFilterCriteriaInput) {
    devices(criteria: $criteria) {
      total
      values {
        imei
        status
        subscription {
          id
        }
        management {
          provider
          ... on AMAPIDeviceManagementOutput {
            nameTail
          }
          ... on ProgetDeviceManagementOutput {
            progetUUID
          }
        }
        model {
          brand
          name
        }
      }
    }
  }
`;

export const FORJA_DEVICE_QUERY: DocumentNode = gql`
  query ForjaDevice($by: DeviceIdentifierInput!) {
    device(by: $by) {
      imei
      status
      subscription {
        id
      }
      management {
        provider
        ... on AMAPIDeviceManagementOutput {
          nameTail
        }
        ... on ProgetDeviceManagementOutput {
          progetUUID
        }
      }
      model {
        brand
        name
      }
    }
  }
`;
